import { XStack, Text } from 'tamagui'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock'
import { useResolvedColors } from './hooks'

export function SecurityNote() {
  const { t } = useTranslation('ProductPage')
  const colors = useResolvedColors()

  return (
    <XStack alignItems="center" gap={8}>
      <FontAwesomeIcon icon={faLock} size={14} color={colors.textLight} />
      <Text color="$text-secondary" fontSize={14} fontFamily="$mulishRegular">
        {t('security')}
      </Text>
    </XStack>
  )
}
